<template>
<b-modal id="my-modal" scrollable 
        :no-close-on-backdrop=true 
        :title="label" 
        :no-close-on-esc=true 
        v-model="isShowPopup" 
        ok-title="Ok" 
        ok-variant="success" 
        @hidden="resetModal"
    >
  <div id="pdfvuer">
    <iframe :src="pdfUrl" style="width: 100%;height: 80vh"></iframe>
<!--    <pdf :src="pdfdata" v-for="i in numPages" :key="i" :id="i" :page="i"-->
<!--      :scale.sync="scale" style="width:100%;margin:20px auto;"-->
<!--        :annotation="true"-->
<!--        :resize="true">-->
<!--    </pdf>-->
  </div>
  <template #modal-footer="{ ok }">
      <b-button size="sm" variant="primary" @click="downloadPDF()"  :disabled="!isLoaded">
        Download
      </b-button>
      <b-button size="sm" variant="success" class="float-right" @click="ok()" :disabled="!isLoaded">
        Ok
      </b-button>
    </template>
    <b-overlay :show="isLoaded == false" no-wrap></b-overlay>
    </b-modal>
</template>

<script>
import pdfvuer from 'pdfvuer';
import 'pdfjs-dist/build/pdf.worker.entry';
import { saveAs } from 'file-saver';

export default {
  components: {
    pdf: pdfvuer
  },
  props: ["openPopup", "pdfUrl","label","resetModalMethod"],
  data () {
    return {
      page: 1,
      numPages: 0,
      pdfdata: undefined,
      errors: [],
      scale: 'page-width',
      src: null,
      progress: 0,
      loadedRatio: 0,
      isLoaded: true,
    }
  },
  computed: {
    formattedZoom () {
        return Number.parseInt(this.scale * 100);
    },
    subTitle() {
        return "Process Id : " + this.processId;
    },
    isShowPopup : {
        get: function () {
          if (this.openPopup) return true;
          else return false;
        },
        set: function (newValue) {}
      }
  },
  mounted () {
    this.getPdf()
  },
  watch: {
    pdfUrl(newValue) {
      this.getPdf(newValue);
    }
  },
  methods: {
    resetModal() {
        if (!this.isLoaded) return;
        this.isLoaded = true;
        this.$emit('resetModalMethod');
      },
      async downloadPDF() {
        let fileName = this.GetFilename(this.pdfUrl);
        await saveAs(this.pdfUrl, fileName);
      },
      GetFilename(url)
      {
        if (url)
        {
            var m = url.toString().match(/.*\/(.+?)\./);
            if (m && m.length > 1)
            {
              return m[1];
            }
        }
        return "";
    },
    getPdf(src) {
      if (!src) return;
      var self = this;
      self.isLoaded = false;
      self.pdfdata = pdfvuer.createLoadingTask(src);
      self.pdfdata.then(pdf => {
        self.numPages = pdf.numPages;
        self.isLoaded = true;
      });
    },
  }
}
</script>
<style src="pdfvuer/dist/pdfvuer.css"></style>
<style lang="scss" scoped>
  .content {
    padding: 16px;
  }

  ::v-deep.modal-footer {
    display: block;
  }
</style>